import {
  AuthorityRole,
  BasicRightType,
  ContactUserRoleType,
  DailyJournalsRightType,
  FinanceAndAccountRights,
  LanguageType,
  Package,
  PartialRightType,
  PeakSource,
  SourceTypeProject,
  UserOrderBy,
  UserRight,
  UserRightSetting,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import store from "@/store/index";
import Cookies from "js-cookie";

const peakDomain = process.env.VUE_APP_PeakDomain;

export function UserId() {
  let sessionUserId: any = sessionStorage.getItem("eui");
  sessionUserId = sessionUserId ? sessionUserId.PeakDecryption() : null;
  return sessionUserId;
}
export function MerchantId() {
  let sessionMerchantId: any = sessionStorage.getItem("emi");
  sessionMerchantId = sessionMerchantId ? sessionMerchantId.PeakDecryption() : null;
  return sessionMerchantId;
}
export function IsSetCookiesInDomain() {
  let isSetDomain = false;

  if (peakDomain) {
    const domainList = location.hostname.split(".");
    const start = -(domainList.length - 1);
    const locationDomain = `.${domainList.slice(start).join(".")}`;

    if (locationDomain == peakDomain) {
      isSetDomain = true;
    }
  }

  return isSetDomain;
}
export function RefreshToken() {
  return Cookies.get("refresh_token");
}
export function AccessToken() {
  return Cookies.get("access_token");
}
export function GetTimezoneOffset() {
  const date = new Date().getTimezoneOffset();
  const timezoneOffset = (date * -1) / 60;
  return timezoneOffset;
}
export function SetCookiesAccessToken(accessToken: any) {
  if (accessToken) {
    if (IsSetCookiesInDomain()) {
      Cookies.set("access_token", accessToken, { domain: peakDomain });
    } else {
      Cookies.set("access_token", accessToken);
    }
  }
}
export function SetCookiesRefreshToken(refreshToken: any, keepLogin = false) {
  if (refreshToken) {
    if (IsSetCookiesInDomain()) {
      if (keepLogin) {
        Cookies.set("refresh_token", refreshToken, { expires: 30, domain: peakDomain });
      } else {
        Cookies.set("refresh_token", refreshToken, { domain: peakDomain });
      }
    } else {
      if (keepLogin) {
        Cookies.set("refresh_token", refreshToken, { expires: 30 });
      } else {
        Cookies.set("refresh_token", refreshToken);
      }
    }
  }
}
export function RemoveCookiesToken() {
  if (IsSetCookiesInDomain()) {
    Cookies.remove("access_token", { domain: peakDomain });
    Cookies.remove("refresh_token", { domain: peakDomain });
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
  } else {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
  }
}
export function GetKeepLogin() {
  return Cookies.get("keepLogin");
}
export function SetCookiesKeepLogin() {
  if (IsSetCookiesInDomain()) {
    Cookies.set("keepLogin", true, { expires: 30, domain: peakDomain });
  } else {
    Cookies.set("keepLogin", true, { expires: 30 });
  }
}
export function RemoveCookiesKeepLogin() {
  if (IsSetCookiesInDomain()) {
    Cookies.remove("keepLogin", { domain: peakDomain });
  } else {
    Cookies.remove("keepLogin");
  }
}
export function GetLanguageType() {
  return i18n.locale == "en" ? LanguageType.En : LanguageType.Th;
}

export function SetHeaderService() {
  return {
    headers: {
      source: SourceTypeProject.PeakTax,
    },
  };
}
export function CheckMerchantPackage(validPackageList: Array<number>) {
  const currentMerchant = store.getters["LogIn/getMerchant"];
  const packageId = currentMerchant.package;
  if (validPackageList.includes(packageId)) {
    return true;
  }
  return false;
}
export function GetRegisterUserTemplate() {
  const registerTemplate = {
    firstName: {
      value: "",
      validateError: false,
    },
    lastName: {
      value: "",
      validateError: false,
    },
    email: {
      value: "",
      validateError: false,
    },
    password: {
      value: "",
      validateError: false,
    },
    passwordConfirm: {
      value: "",
      validateError: false,
    },
    check: false,
    acceptPolicy: "",
    telephone: {
      value: "",
      validateError: false,
    },
    position: {
      value: "",
      validateError: false,
    },
    department: {
      value: "",
      validateError: false,
    },
    birthday: {
      value: new Date(0),
      validateError: false,
    },
    addposition: {
      value: "",
      validateError: false,
    },
    adddepartment: {
      value: "",
      validateError: false,
    },
    imageProfile: {
      fileName: "",
      fileType: "",
      rawString: "",
      urlImg: "",
      isSeleted: false,
    },
    referrerUserId: 0,
  };

  return registerTemplate;
}

export function ValidateTemplateModel(userTemplate: any) {
  let isValidate = true;

  if (!userTemplate.firstName.value || userTemplate.firstName.validateError) {
    isValidate = false;
    userTemplate.firstName.validateError = true;
  } else {
    userTemplate.firstName.validateError = false;
  }

  if (!userTemplate.lastName.value || userTemplate.lastName.validateError) {
    isValidate = false;
    userTemplate.lastName.validateError = true;
  } else {
    userTemplate.lastName.validateError = false;
  }

  if (!userTemplate.phone.value) {
    isValidate = false;
    userTemplate.phone.validateError = true;
  } else {
    userTemplate.phone.validateError = false;
  }

  if (userTemplate.department.value.value == 0) {
    if (!userTemplate.departmentOther.value || userTemplate.departmentOther.validateError) {
      isValidate = false;
      userTemplate.departmentOther.validateError = true;
    } else {
      userTemplate.departmentOther.validateError = false;
    }
  }

  if (userTemplate.position.value.value == 0) {
    if (!userTemplate.positionOther.value || userTemplate.positionOther.validateError) {
      isValidate = false;
      userTemplate.positionOther.validateError = true;
    } else {
      userTemplate.positionOther.validateError = false;
    }
  }

  return isValidate;
}

export function GetUserTemplate(userModel: any) {
  const userTemplate = {
    id: userModel.userId,
    pictureImg: {
      croppa: {},
      fileName: "",
      fileType: "",
      rawString: "",
      urlImg: userModel.pictureUrl,
      objectUrl: "",
    },
    isUpdatePictureImg: false,
    signatureImg: {
      croppa: {},
      fileName: "",
      fileType: "",
      rawString: "",
      urlImg: userModel.signatureUrl,
      objectUrl: "",
    },
    isUpdateSignatureImg: false,
    firstName: {
      value: userModel.firstName,
      validateError: false,
    },
    lastName: {
      value: userModel.lastName,
      validateError: false,
    },
    phone: {
      value: userModel.phone,
      validateError: false,
    },
    userEmail: {
      value: userModel.userEmail,
      validateError: false,
    },
    birthdate: {
      value: userModel.birthdate,
      validateError: false,
    },
    department: {
      value: { value: userModel.departmentId !== null ? userModel.departmentId : -1 },
      validateError: false,
    },
    departmentOther: {
      value: userModel.departmentOther ? userModel.departmentOther : "",
      validateError: false,
    },
    position: {
      value: { value: userModel.positionId !== null ? userModel.positionId : -1 },
      validateError: false,
    },
    positionOther: {
      value: userModel.positionOther ? userModel.positionOther : "",
      validateError: false,
    },
  };
  return userTemplate;
}

export function SetHeaderTableUser() {
  const header = [
    {
      name: "check",
      hidden: true,
      checkAll: false,
    },
    {
      name: "Username",
      sortBy: UserOrderBy.DisplayName,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "User_Right_Title",
      sortBy: null,
      sortingType: null,
      align: "flex-start",
    },
    {
      name: "Last_Use",
      sortBy: UserOrderBy.LastestLogin,
      sortingType: null,
      align: "flex-start",
      positionTooltip: "bottom",
      tooltip: "User_Setting_Last_Login_Tooltip",
    },
    {
      name: "",
      sortBy: null,
      sortingType: null,
      align: "center",
    },
  ];

  return header;
}

export function SetTapsUserTable() {
  const taps = [
    {
      name: "",
      length: 0,
      bgLengthColor: "gray",
      showtableCount: false,
      tableViewStatusType: 0,
      active: true,
    },
  ];
  return taps;
}

export function ConvertToManageFinanceAndJournals(role6: any) {
  const manageFinanceAndJournals = {
    FinanceAccess: { value: false },
    ChartofAccountAndGL: { value: false },
    DailyJournalsAccess: {
      value: false,
      DailyJournalsRightType: { name: i18n.t("Select_DailyJournals.All"), value: DailyJournalsRightType.All },
    },
  };

  switch (role6) {
    case FinanceAndAccountRights.All:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.All;
      break;
    case FinanceAndAccountRights.FinanceAccessOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
    case FinanceAndAccountRights.GLAndStatementOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
    case FinanceAndAccountRights.DailyJournalsAll:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.All;
      break;
    case FinanceAndAccountRights.DailyJournalsDraftOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.DraftOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsApproveOnly:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.ApproveOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsAllAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.All;
      break;
    case FinanceAndAccountRights.DailyJournalsDraftOnlyAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.DraftOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsApproveOnlyAndFinance:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = false;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.ApproveOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsAllAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.All;
      break;
    case FinanceAndAccountRights.DailyJournalsDraftOnlyAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.DraftOnly;
      break;
    case FinanceAndAccountRights.DailyJournalsApproveOnlyAndGL:
      manageFinanceAndJournals.FinanceAccess.value = false;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.ApproveOnly;
      break;
    case FinanceAndAccountRights.FinanceAccountAndDailyJournalsDraftOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.DraftOnly;
      break;
    case FinanceAndAccountRights.FinanceAccountAndDailyJournalsApproveOnly:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value = DailyJournalsRightType.ApproveOnly;
      break;
    case FinanceAndAccountRights.FinanceAndGL:
      manageFinanceAndJournals.FinanceAccess.value = true;
      manageFinanceAndJournals.ChartofAccountAndGL.value = true;
      manageFinanceAndJournals.DailyJournalsAccess.value = false;
      break;
  }
  return manageFinanceAndJournals;
}
export function ConvertToUserRole6(manageFinanceAndJournals: any) {
  let role6 = 0;
  if (
    manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.All
  ) {
    role6 = FinanceAndAccountRights.All;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    !manageFinanceAndJournals.DailyJournalsAccess.value
  ) {
    role6 = FinanceAndAccountRights.FinanceAccessOnly;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    !manageFinanceAndJournals.DailyJournalsAccess.value
  ) {
    role6 = FinanceAndAccountRights.GLAndStatementOnly;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.All
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsAll;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.DraftOnly
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsDraftOnly;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.ApproveOnly
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsApproveOnly;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.All
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsAllAndFinance;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.DraftOnly
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsDraftOnlyAndFinance;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    !manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.ApproveOnly
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsApproveOnlyAndFinance;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.All
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsAllAndGL;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.DraftOnly
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsDraftOnlyAndGL;
  } else if (
    !manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.ApproveOnly
  ) {
    role6 = FinanceAndAccountRights.DailyJournalsApproveOnlyAndGL;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.DraftOnly
  ) {
    role6 = FinanceAndAccountRights.FinanceAccountAndDailyJournalsDraftOnly;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    manageFinanceAndJournals.DailyJournalsAccess.value &&
    manageFinanceAndJournals.DailyJournalsAccess.DailyJournalsRightType.value == DailyJournalsRightType.ApproveOnly
  ) {
    role6 = FinanceAndAccountRights.FinanceAccountAndDailyJournalsApproveOnly;
  } else if (
    manageFinanceAndJournals.FinanceAccess.value &&
    manageFinanceAndJournals.ChartofAccountAndGL.value &&
    !manageFinanceAndJournals.DailyJournalsAccess.value
  ) {
    role6 = FinanceAndAccountRights.FinanceAndGL;
  }
  return role6;
}
function ConvertToUserRole12(manageContact: any) {
  let role12 = ContactUserRoleType.None;
  if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.All;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAndAddContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.editContact &&
    !manageContact.addContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAndEditContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.deleteContact &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAndDeleteContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.exportContact &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.editContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAddAndEditContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.deleteContact &&
    !manageContact.editContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAddAndDeleteContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.exportContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAddAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    !manageContact.addContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.ContactAccessEditAndDeleteContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.editContact &&
    manageContact.exportContact &&
    !manageContact.addContact &&
    !manageContact.deleteContact
  ) {
    role12 = ContactUserRoleType.ContactAccessEditAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.addContact &&
    !manageContact.editContact
  ) {
    role12 = ContactUserRoleType.ContactAccessDeleteAndExportContact;
  } else if (
    manageContact.addContact &&
    manageContact.editContact &&
    !manageContact.contactAccess &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.AddAndEditContact;
  } else if (
    manageContact.addContact &&
    manageContact.deleteContact &&
    !manageContact.contactAccess &&
    !manageContact.editContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.AddAndDeleteContact;
  } else if (
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    !manageContact.contactAccess &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.AddEditAndDeleteContact;
  } else if (
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.DeleteContact
  ) {
    role12 = ContactUserRoleType.AddEditAndExportContact;
  } else if (
    manageContact.addContact &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.editContact
  ) {
    role12 = ContactUserRoleType.AddDeleteAndExportContact;
  } else if (
    manageContact.editContact &&
    manageContact.deleteContact &&
    !manageContact.addContact &&
    !manageContact.exportContact &&
    !manageContact.contactAccess
  ) {
    role12 = ContactUserRoleType.EditAndDeleteContact;
  } else if (
    manageContact.editContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.deleteContact
  ) {
    role12 = ContactUserRoleType.EditAndExportContact;
  } else if (
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess
  ) {
    role12 = ContactUserRoleType.AddEditDeleteAndExportContact;
  } else if (
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.editContact
  ) {
    role12 = ContactUserRoleType.DeleteAndExportContact;
  } else if (
    manageContact.deleteContact &&
    manageContact.exportContact &&
    manageContact.editContact &&
    !manageContact.addContact &&
    !manageContact.contactAccess
  ) {
    role12 = ContactUserRoleType.DeleteExportAndEditContact;
  } else if (
    manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.ContactAccess;
  } else if (
    manageContact.addContact &&
    !manageContact.contactAccess &&
    !manageContact.editContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.AddContact;
  } else if (
    manageContact.editContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.EditContact;
  } else if (
    manageContact.deleteContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.DeleteContact;
  } else if (
    manageContact.exportContact &&
    !manageContact.contactAccess &&
    !manageContact.addContact &&
    !manageContact.editContact &&
    !manageContact.deleteContact
  ) {
    role12 = ContactUserRoleType.ExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    !manageContact.exportContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAddEditAndDeleteContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.editContact &&
    manageContact.exportContact &&
    !manageContact.deleteContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAddEditAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.addContact &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.editContact
  ) {
    role12 = ContactUserRoleType.ContactAccessAddDeleteAndExportContact;
  } else if (
    manageContact.contactAccess &&
    manageContact.editContact &&
    manageContact.deleteContact &&
    manageContact.exportContact &&
    !manageContact.addContact
  ) {
    role12 = ContactUserRoleType.ContactAccessEditDeleteAndExportContact;
  }
  return role12;
}
function ConvertToContactUserRoleType(role12: any) {
  const manageContact = {
    contactAccess: false,
    addContact: false,
    editContact: false,
    deleteContact: false,
    exportContact: false,
  };

  switch (role12) {
    case ContactUserRoleType.All:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.ContactAccessAndAddContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.ContactAccessAndEditContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.ContactAccessAndDeleteContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.ContactAccessAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.ContactAccessAddAndEditContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.ContactAccessAddAndDeleteContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.ContactAccessAddAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.ContactAccessEditAndDeleteContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.ContactAccessEditAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.ContactAccessDeleteAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.AddAndEditContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.AddAndDeleteContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.AddAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.AddEditAndDeleteContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.AddEditAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.AddDeleteAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.EditAndDeleteContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.EditAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.AddEditDeleteAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.DeleteAndExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.DeleteExportAndEditContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.ContactAccess:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.AddContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.EditContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.DeleteContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.ExportContact:
      (manageContact.contactAccess = false),
        (manageContact.addContact = false),
        (manageContact.editContact = false),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.ContactAccessAddEditAndDeleteContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = false);
      break;
    case ContactUserRoleType.ContactAccessAddEditAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = true),
        (manageContact.deleteContact = false),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.ContactAccessAddDeleteAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = true),
        (manageContact.editContact = false),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
    case ContactUserRoleType.ContactAccessEditDeleteAndExportContact:
      (manageContact.contactAccess = true),
        (manageContact.addContact = false),
        (manageContact.editContact = true),
        (manageContact.deleteContact = true),
        (manageContact.exportContact = true);
      break;
  }
  return manageContact;
}

export function GetSettingUserRoleTemplate(_userDetail: any = null) {
  const settingUserRoleTemplate = {
    userRole: UserRightSetting.ViewOnly,
    partialRight: { value: PartialRightType.DraftOnly },
    basicRight: { value: BasicRightType.CanViewExport },
    isManageUser: false,
    isManageFinance: false,
    isManageProduct: false,
    isUsePayroll: false,
    isUsePeakBoard: false,
    authorityRole: AuthorityRole.None,
    manageFinanceAndJournals: {
      FinanceAccess: { value: false },
      ChartofAccountAndGL: { value: false },
      DailyJournalsAccess: {
        value: false,
        DailyJournalsRightType: { name: i18n.t("Select_DailyJournals.All"), value: DailyJournalsRightType.All },
      },
    },
    isManageAsset: false,
    manageContact: {
      contactAccess: true,
      addContact: true,
      editContact: true,
      deleteContact: true,
      exportContact: true,
    },
  };
  if (_userDetail) {
    switch (_userDetail.merchantUserRoleType) {
      case UserRight.ViewOnly:
        settingUserRoleTemplate.userRole = UserRightSetting.ViewOnly;
        break;
      case UserRight.RevenueExpenseDraftOnly:
        settingUserRoleTemplate.userRole = UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = PartialRightType.DraftOnly;
        break;
      case UserRight.RevenueExpenseApproveOnly:
        settingUserRoleTemplate.userRole = UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = PartialRightType.ApproveAndPaymentOnly;
        break;
      case UserRight.RevenueAll:
        settingUserRoleTemplate.userRole = UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = PartialRightType.RevenueOnly;
        break;
      case UserRight.ExpenseAll:
        settingUserRoleTemplate.userRole = UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = PartialRightType.ExpenseOnly;
        break;
      case UserRight.QuotationOnly:
        settingUserRoleTemplate.userRole = UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = PartialRightType.QuotationOnly;
        break;
      case UserRight.Standard:
        settingUserRoleTemplate.userRole = UserRightSetting.Basic;
        settingUserRoleTemplate.basicRight.value = BasicRightType.ConNotViewExport;
        break;
      case UserRight.BasicAndAdmin:
        settingUserRoleTemplate.userRole = UserRightSetting.Admin;
        break;
      case UserRight.CreateRevenueOnly:
        settingUserRoleTemplate.userRole = UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = PartialRightType.CreateRevenueOnly;
        break;
      case UserRight.CreateExpenseOnly:
        settingUserRoleTemplate.userRole = UserRightSetting.Partial;
        settingUserRoleTemplate.partialRight.value = PartialRightType.CreateExpenseOnly;
        break;
    }

    settingUserRoleTemplate.isManageUser = _userDetail.manageUser;
    settingUserRoleTemplate.isManageProduct = _userDetail.manageProduct;
    settingUserRoleTemplate.isUsePayroll = _userDetail.isUsePayroll;
    settingUserRoleTemplate.isUsePeakBoard = _userDetail.isUsePeakBoard;
    settingUserRoleTemplate.authorityRole = _userDetail.authorityRole;
    settingUserRoleTemplate.manageFinanceAndJournals = ConvertToManageFinanceAndJournals(
      _userDetail.userRoleModel.role6
    );
    settingUserRoleTemplate.isManageAsset = _userDetail.manageAsset;
  }

  return settingUserRoleTemplate;
}

export function GetUserDetailTemplate(_userDetail: any) {
  const userDetailTemplate = {
    email: _userDetail.email,
    firstName: _userDetail.firstName,
    lastName: _userDetail.lastName,
    settingUserRole: GetSettingUserRoleTemplate(_userDetail),
  };
  return userDetailTemplate;
}

export function ConverToUserRoleModel(_settingUesrRole: any) {
  const settingUserRole = {
    role1: 0,
    role2: 0,
    role3: 0,
    role4: 0,
    role5: _settingUesrRole.isManageUser ? 1 : 0,
    role6: ConvertToUserRole6(_settingUesrRole.manageFinanceAndJournals),
    role7: _settingUesrRole.isUsePayroll ? 1 : 0,
    role8: _settingUesrRole.isUsePeakBoard ? 1 : 0,
    role9: _settingUesrRole.isManageProduct ? 1 : 0,
    role10: _settingUesrRole.isSeeSelfDocuments ? 1 : 0,
    role11: _settingUesrRole.isManageAsset ? 1 : 0,
    role12: ConvertToUserRole12(_settingUesrRole.manageContact),
  };

  switch (_settingUesrRole.userRole) {
    case UserRightSetting.ViewOnly:
      settingUserRole.role1 = 2;
      break;
    case UserRightSetting.Partial:
      switch (_settingUesrRole.partialRight.value) {
        case PartialRightType.DraftOnly:
          settingUserRole.role1 = 3;
          break;
        case PartialRightType.ApproveAndPaymentOnly:
          settingUserRole.role1 = 4;
          break;
        case PartialRightType.RevenueOnly:
          settingUserRole.role1 = 5;
          break;
        case PartialRightType.ExpenseOnly:
          settingUserRole.role1 = 6;
          break;

        case PartialRightType.QuotationOnly:
          settingUserRole.role1 = 7;
          break;
        case PartialRightType.CreateRevenueOnly:
          settingUserRole.role1 = 8;
          break;
        case PartialRightType.CreateExpenseOnly:
          settingUserRole.role1 = 9;
          break;
      }
      break;
    case UserRightSetting.Basic:
      switch (_settingUesrRole.basicRight.value) {
        case BasicRightType.CanViewExport:
          settingUserRole.role1 = 1;
          settingUserRole.role2 = 1;
          settingUserRole.role3 = 1;
          break;
        case BasicRightType.ConNotViewExport:
          settingUserRole.role1 = 1;
          settingUserRole.role3 = 1;
          break;
      }
      break;
    case UserRightSetting.Admin:
      settingUserRole.role1 = 1;
      settingUserRole.role2 = 1;
      settingUserRole.role3 = 1;
      settingUserRole.role4 = 1;
      break;
  }

  return settingUserRole;
}

export function ConvertToInputUpdateUser(userDetailTemplate: any, userId: number) {
  const inputUpdateUser = {
    userId: userId,
    userRole: ConverToUserRoleModel(userDetailTemplate.settingUserRole),
  };

  return inputUpdateUser;
}

export function GetAddUserTemplate() {
  const addUserTemplate = {
    email: { value: "", validateError: "" },
    settingUserRole: GetSettingUserRoleTemplate(),
  };

  return addUserTemplate;
}

export function ConvertToInputAddNewUser(addUserTemplate: any) {
  const inputAddNewUser = {
    userName: addUserTemplate.email.value,
    manageUser: addUserTemplate.settingUserRole.isManageUser,
    manageFinanceAndJournals: ConvertToUserRole6(addUserTemplate.settingUserRole.manageFinanceAndJournals),
    isUsePayroll: addUserTemplate.settingUserRole.isUsePayroll,
    isUsePeakBoard: addUserTemplate.settingUserRole.isUsePeakBoard,
    userRoleModel: ConverToUserRoleModel(addUserTemplate.settingUserRole),
    manageContact: ConvertToUserRole12(addUserTemplate.settingUserRole.manageContact),
    source: PeakSource.PeakTax,
  };
  return inputAddNewUser;
}

export function CheckMerchantAFPPackage() {
  return CheckMerchantPackage([Package.AFPFree, Package.AFPLedger, Package.AFPAccountant]);
}
